module.exports = __webpack_public_path__ + "img/fruct25_demo2.9bc658d6.jpg";